import { FC } from 'react'

import { Card, LoadingSpinner } from '@/components'
import { EditLeaveOfAbsenceForm } from '@/containers'
import { LeaveOfAbsence, LeaveOfAbsenceForm } from '@/entities/LeaveOfAbsences/LeaveOfAbsences'
import { leaveOfAbsenceStatus } from '@/types'

interface LeaveOfAbsenceEditContainerProps {
    leaveOfAbsence?: LeaveOfAbsence
    isLoading: boolean
    onSubmit: (formData: LeaveOfAbsenceForm) => void
    onCancelChangeRequest?: () => void
    className?: string
}

export const LeaveOfAbsenceEditContainer: FC<LeaveOfAbsenceEditContainerProps> = ({
    leaveOfAbsence,
    isLoading,
    onSubmit,
    onCancelChangeRequest,
    className = '',
}) => {
    const emptyState = ! leaveOfAbsence || Object.keys(leaveOfAbsence).length === 0

    const status = leaveOfAbsence?.status
    const color = status ? leaveOfAbsenceStatus[status]?.color : undefined

    if (isLoading || emptyState) {
        return <LoadingSpinner />
    }

    return (
        <div className={`leave-of-absence-edit ${className}`}>
            <Card
                color={color}
                className="leave-of-absence-edit__card"
            />

            <EditLeaveOfAbsenceForm
                leaveOfAbsence={leaveOfAbsence}
                isLoading={isLoading}
                onSubmit={onSubmit}
                onCancelChangeRequest={onCancelChangeRequest}
            />
        </div>
    )
}
